import React, { } from 'react';
import { useTranslation } from 'react-i18next';
import { useCancelForm } from '../../clients/hooks/useCancelForm';
import { RootStateOrAny, useSelector } from 'react-redux';
import { wrapper } from '../../reports/styles/style';
import OrderDetailTxt from '../../orders/components/forms/edditOrder/OrderDetailTxt';
import { translateDocumentType } from '../models/DocumentTypeEnums';

const StoreDocsShowForm = () => {
    const { t } = useTranslation("admin");
    const { selectedStoreDocs } = useSelector(
        (state: RootStateOrAny) => state.storeDocs
    );

    const cancel = useCancelForm();

    return (
        <div className={wrapper}>
            {selectedStoreDocs[0] && (
                <div>
                    {selectedStoreDocs[0].documentStatusStr != undefined ?
                        <OrderDetailTxt
                            title={t("nav.documentStatus") as string}
                            value={selectedStoreDocs[0].documentStatusStr}
                        /> : <></>}
                    {selectedStoreDocs[0].description != undefined ?
                        <OrderDetailTxt
                            title={t("nav.documentNumber") as string}
                            value={selectedStoreDocs[0].description}
                        /> : <></>}
                    {selectedStoreDocs[0].documentDate != undefined ?
                        <OrderDetailTxt
                            title={t("nav.issueDate") as string}
                            value={selectedStoreDocs[0].documentDate}
                        /> : <></>}
                    {selectedStoreDocs[0].documentTypeName != undefined ?
                        <OrderDetailTxt
                            title={t("nav.panelType") as string}
                            value={translateDocumentType(selectedStoreDocs[0].documentType, selectedStoreDocs[0].documentTypeName, t)}
                        /> : <></>}
                    {selectedStoreDocs[0].companyName != undefined ?
                        <OrderDetailTxt
                            title={t("nav.clientLabel") as string}
                            value={selectedStoreDocs[0].companyName}
                        /> : <></>}
                    {selectedStoreDocs[0].receptionPlaceName != undefined ?
                        <OrderDetailTxt
                            title={t("nav.panelPickupPoint") as string}
                            value={selectedStoreDocs[0].receptionPlaceName}
                        /> : <></>}
                    {selectedStoreDocs[0].internalStoreName != undefined ?
                        <OrderDetailTxt
                            title={t("nav.panelInternalWarehouse") as string}
                            value={selectedStoreDocs[0].internalStoreName}
                        /> : <></>}
                    {selectedStoreDocs[0].containersNumber != undefined ?
                        <OrderDetailTxt
                            title={t("nav.containersQuantity") as string}
                            value={selectedStoreDocs[0].containersNumber}
                        /> : <></>}
                </div>
            )}
        </div>
    )
};

export default StoreDocsShowForm;